import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import {
  message, Select, Icon, Menu, Dropdown, Button, Select as AntdSelect, Modal, AutoComplete,
} from 'antd'
import { useQuery, useMutation } from '@apollo/react-hooks'
import {
  SmallText, Div, Button as KonsysButton, Loading, InputWithLabel,
} from 'konsys-ui'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { UPDATE_SERIAL, CHANGE_SERIAL_NUMBER } from '../../constants/graph/mutation'
import { status, statusText, LOSTREASON } from '../../pages/tire-inventory-page/constants'
import { P } from '../../pages/tire-inventory-page/styled'
import PERMISSION from '../../constants/permissions'
import { TRANSPORT_WAREHOUSE_ID } from '../../pages/inventory-page/constants'

const { color } = theme

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange, value }) => (
  <input placeholder='ค้นหา' onChange={(e) => {
    handleChange(e.target.value)
  }} value={value}/>
)

const menu = (id, serial) => (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_TIRE_INVENTORY)}>
        <Link target="_blank" to={{ pathname: `/tire-inventory/view/${id}`, search: `?serial=${serial}` }}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_TIRE_INVENTORY)}>
        <Link target="_blank" to={`/tire-inventory/edit/${id}`}>
          แก้ไข
        </Link>
      </Menu.Item>
      {/* <Menu.Item key='transfer' disabled={!_.includes(window.perms, PERMISSION.UPDATE_GARAGE)}>
        <Link target="_blank" to={`/tire-inventory/transfer/${id}`}>
          โอนย้ายสต๊อก
        </Link>
      </Menu.Item>
      <Menu.Item key='adjust' disabled={!_.includes(window.perms, PERMISSION.UPDATE_GARAGE)}>
        <Link target="_blank" to={`/tire-inventory/adjust/${id}`}>
          แก้ไขจำนวนสต๊อก
        </Link>
      </Menu.Item> */}
      <Menu.Item key='history' disabled={!_.includes(window.perms, PERMISSION.VIEW_TIRE_INVENTORY)}>
        <Link target="_blank" to={`/tire-inventory/history/${id}`}>
          ประวัติ
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const ActionSelector = ({ props: { original: { id } }, serial }) => (
  <Dropdown overlay={menu(id, serial)} trigger='click'>
    <Button>
      ดูรายละเอียด <Icon type="down" />
    </Button>
  </Dropdown>
)

const tireMenu = (original, setTransferModal, setRemoveModal, setIsRemove, setEditModal) => (
  <Div>
    <Menu
      selectedKeys={[null]}
      onSelect={(e) => {
        if (e.key === 'edit') setEditModal(true)
        if (e.key === 'transfer') setTransferModal(true)
        if (e.key === 'remove') {
          setRemoveModal(true)
          if (_.includes(['LOST', 'SOLD'], original.status)) setIsRemove(false)
          else setIsRemove(true)
        }
      }}>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_TIRE_INVENTORY)}>
        <Link target="_blank" to={`/tire-inventory/used-history/${original.id}`}>
          ดูประวัติการใช้งาน
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_TIRE_INVENTORY) || _.includes(['LOST', 'SOLD'], original.status)}>
          แก้ไขเบอร์ยาง
      </Menu.Item>
      <Menu.Item key='transfer' disabled={!_.includes(window.perms, PERMISSION.UPDATE_TIRE_INVENTORY) || _.includes(['USING', 'LOST', 'SOLD'], original.status)}>
          โอนย้ายสต๊อก
      </Menu.Item>
      <Menu.Item key='remove' disabled={!_.includes(window.perms, PERMISSION.UPDATE_TIRE_INVENTORY) || original.status === 'USING'}>
        {
          _.includes(['LOST', 'SOLD'], original.status)
            ? 'นำกลับมาใช้'
            : 'นำออก'
        }
      </Menu.Item>
    </Menu>
  </Div>
)

export const SerialActionSelector = ({ props: { original }, refetch, warehousesData }) => {
  const [transferModal, setTransferModal] = useState(false)
  const [removeModal, setRemoveModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [isRemove, setIsRemove] = useState(true)
  return (
  <Div>
    <Dropdown overlay={tireMenu(original, setTransferModal, setRemoveModal, setIsRemove, setEditModal)} trigger='click'>
      <Button>
        ดูรายละเอียด <Icon type="down" />
      </Button>
    </Dropdown>
    <TransferModal data={original} transferModal={transferModal} setTransferModal={setTransferModal} refetch={refetch} warehousesData={warehousesData}/>
    <RemoveModal data={original} removeModal={removeModal} setRemoveModal={setRemoveModal} refetch={refetch} isRemove={isRemove}/>
    <EditModal data={original} editModal={editModal} setEditModal={setEditModal} refetch={refetch} />
  </Div>
  )
}


export const DropdownSelector = ({
  data, handleChange, TireType,
}) => {
  const width = TireType ? '210px' : '100px'
  return (
    <AntdSelect
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
    >
    {
      data.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
    }
    </AntdSelect>
  )
}

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled,
}) => (
  <Div
    position='fixed'
    height='72px'
    bottom='0'
    left='0'
    right='0'
    style={{ background: `${color.primaryColor}33` }}
    display='flex'
    justifyContent='flex-end'
    alignItems='center'
    padding='0 32px 0 0'
  >
    <KonsysButton
      loading={loading}
      disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_TIRE_INVENTORY)) || disabled}
      text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
      icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
      inverse
      onClick={() => {
        if (isViewMode) history.push(`/inventory/edit/${props.match.params.id}`)
        else {
          doAction({
            variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
          }).then(({ data }) => {
            const resp = isAddMode ? data.createInventoryForTire : data.updateInventoryTire
            if (resp.success) {
              message.success(resp.message)
              if (isAddMode) history.push('/inventory')
              // else {
              //   refetch()
              //   history.push(`/mechanic/view/${props.match.params.id}`)
              // }
            } else message.error(resp.message)
          })
        }
      }}
    />
  </Div>
)

const TransferModal = ({
  data, transferModal, setTransferModal, refetch, warehousesData,
}) => {
  const [warehouseId, setWarehouseId] = useState(data.Warehouse.id)
  const [doAction, { loading: mutationLoading }] = useMutation(UPDATE_SERIAL)
  // if (mutationLoading) return <Loading center='true' />
  return (
    <Modal
    title="ย้ายสต๊อกยาง"
    visible={transferModal}
    destroyOnClose={true}
    onCancel={() => {
      setTransferModal(false)
      setWarehouseId(data.Warehouse.id)
    }}
    onOk={() => {
      doAction({
        variables: {
          warehouseId,
          id: data.id,
          serialNumber: data.serialNumber,
          status: data.status,
        },
      }).then((resp) => {
        const KEY = 'UpdateTireSerialNumber'
        if (resp.data[KEY].success) {
          message.success(resp.data[KEY].message)
          refetch()
        } else message.error(resp.data[KEY].message)
      })
      setTransferModal(false)
      setWarehouseId(data.Warehouse.id)
    }}
    okButtonProps={{
      loading: mutationLoading,
    }}
    cancelButtonProps={{
      disabled: mutationLoading,
    }}
  >
  <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <P margin='8px 32px 16px 0'>เลือกคลังสินค้า</P>
        <Select
          dropdown
          maxHeight='none'
          style={{ width: '500px' }}
          onChange={e => setWarehouseId(e)}
        >
        {
          warehousesData.warehouseList.data.list.map(v => <Select.Option key={v.id} value={v.id}>{v.warehouseName}</Select.Option>)
        }
      </Select>
  </Div>
  </Modal>
  )
}

const RemoveModal = ({
  data, removeModal, setRemoveModal, refetch, isRemove,
}) => {
  const [reason, setReason] = useState('')
  const [doAction, { loading: mutationLoading }] = useMutation(UPDATE_SERIAL)
  return (
    <Modal
    title={isRemove ? 'นำยางออก' : 'นำกลับมาใช้'}
    visible={removeModal}
    destroyOnClose={true}
    onCancel={() => {
      setRemoveModal(false)
      setReason('')
    }}
    onOk={() => {
      doAction({
        variables: {
          warehouseId: data.Warehouse.id,
          id: data.id,
          serialNumber: data.serialNumber,
          status: isRemove ? 'LOST' : 'OLDSTOCK',
          lostReason: isRemove ? reason : null,
        },
      }).then((resp) => {
        const KEY = 'UpdateTireSerialNumber'
        if (resp.data[KEY].success) {
          message.success(resp.data[KEY].message)
          refetch()
        } else message.error(resp.data[KEY].message)
      })
      setRemoveModal(false)
      setReason('')
    }}
    okButtonProps={{
      loading: mutationLoading,
    }}
    cancelButtonProps={{
      disabled: mutationLoading,
    }}
  >
      {/* <InputWithLabel
      title={{ text: 'ใส่เหตุผล' }}
      margin='0 16px 0 0'
      input={{ onChange: e => setReason(e.target.value), value: reason }} /> */}
      {
        isRemove
        && <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
          <P margin='8px 32px 16px 0'>สาเหตุ</P>
          <AutoComplete
            dataSource={LOSTREASON}
            value={reason}
            style={{ width: 500 }}
            onSelect={(e) => {
              setReason(e)
            }}
            onSearch={(e) => {
              setReason(e)
            }}
            placeholder="กรุณาระบุสาเหตุ"
          />
        </Div>
      }
  </Modal>
  )
}

const EditModal = ({
  data, editModal, setEditModal, refetch,
}) => {
  const [doAction, { loading: mutationLoading }] = useMutation(CHANGE_SERIAL_NUMBER)
  const [serialNumber, setSerialNumber] = useState(data.serialNumber)
  useEffect(() => {
    setSerialNumber(data.serialNumber)
  }, [data])
  return (
    <Modal
    title='เปลี่ยนเบอร์ยาง'
    visible={editModal}
    destroyOnClose={true}
    onCancel={() => {
      setEditModal(false)
    }}
    onOk={() => {
      doAction({
        variables: {
          id: data.id,
          serialNumber,
        },
      }).then((resp) => {
        const KEY = 'ChangeTireSerialNumber'
        if (resp.data[KEY].success) {
          message.success(resp.data[KEY].message)
          refetch()
        } else message.error(resp.data[KEY].message)
      })
      setEditModal(false)
    }}
    okButtonProps={{
      loading: mutationLoading,
    }}
    cancelButtonProps={{
      disabled: mutationLoading,
    }}
  >
    <InputWithLabel
      title={{ text: 'เบอร์ยาง' }}
      margin='0 16px 0 0'
      input={{ onChange: e => setSerialNumber(e.target.value), value: serialNumber }}
    />
  </Modal>
  )
}
